const STORAGE_KEY = "workspace-onboarding:pending-checkout";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function loadWorkspaceOnboardingSession(userId) {
    try {
        const session = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
        const expired = !session?.updatedAt || Date.now() - Number(session.updatedAt) > MAX_AGE_MS;
        const wrongUser = userId && String(session?.userId) !== String(userId);
        if (!session?.workspace?.documentId || !session?.idempotencyKey || expired || wrongUser) {
            window.sessionStorage.removeItem(STORAGE_KEY);
            return null;
        }
        return session;
    } catch {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return null;
    }
}

export function saveWorkspaceOnboardingSession(session) {
    const value = {...session, updatedAt: Date.now()};
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    return value;
}

export function clearWorkspaceOnboardingSession(workspaceDocumentId) {
    const session = loadWorkspaceOnboardingSession();
    if (!session) return;
    if (!workspaceDocumentId || session.workspace.documentId === workspaceDocumentId) {
        window.sessionStorage.removeItem(STORAGE_KEY);
    }
}

export function markWorkspaceOnboardingCheckoutRetry(workspaceDocumentId) {
    const session = loadWorkspaceOnboardingSession();
    if (!session || (workspaceDocumentId && session.workspace.documentId !== workspaceDocumentId)) return;
    saveWorkspaceOnboardingSession({
        ...session,
        retryCheckout: true,
        authority: null,
        paymentDocumentId: null,
    });
}

export function markWorkspaceOnboardingPaymentCompleted(workspaceDocumentId) {
    const session = loadWorkspaceOnboardingSession();
    if (!session || (workspaceDocumentId && session.workspace.documentId !== workspaceDocumentId)) return null;
    return saveWorkspaceOnboardingSession({
        ...session,
        paymentCompleted: true,
        retryCheckout: false,
        authority: null,
        paymentDocumentId: null,
    });
}
